import { render, staticRenderFns } from "./ion-search.vue?vue&type=template&id=246dfd39"
import script from "./ion-search.vue?vue&type=script&lang=js"
export * from "./ion-search.vue?vue&type=script&lang=js"
import style0 from "./ion-search.vue?vue&type=style&index=0&id=246dfd39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports